import { type Components, type Theme } from "@mui/material/styles";

import { type AvatarSize } from "../../components/Avatar";

declare module "@mui/material/Avatar" {
  interface AvatarOwnProps {
    size?: AvatarSize;
  }
}

export const muiAvatarOverrides: Components<Theme> = {
  MuiAvatar: {
    defaultProps: {
      size: "medium",
    },
    styleOverrides: {
      root: ({ theme }) => ({
        backgroundColor: theme.palette.background.default,

        variants: [
          {
            props: { size: "medium" },
            style: {
              width: theme.size?.avatar.medium.size,
              height: theme.size?.avatar.medium.size,
              outlineWidth: theme.size?.avatar.medium.outlineSize,
              outlineOffset: theme.size?.avatar.medium.outlineSize,

              "& .MuiTypography-root": {
                ...theme.typography.caption,
              },
            },
          },
          {
            props: { size: "large" },
            style: {
              width: theme.size?.avatar.large.size,
              height: theme.size?.avatar.large.size,
              outlineWidth: theme.size?.avatar.large.outlineSize,
              outlineOffset: theme.size?.avatar.large.outlineSize,

              "& .MuiTypography-root": {
                ...theme.typography.h5,
              },
            },
          },
        ],
      }),

      // Displayed when there is no image
      colorDefault: ({ theme }) => ({
        backgroundColor: theme.palette.background.inactive,
        color: theme.palette.text.primary,
      }),
    },
  },
};
